import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Painel de usuário: acesso total no plano gratuito. Assinatura é exigida apenas ao cadastrar um bot (tratado na ação). */

interface ProtectedRouteProps {
    children: React.ReactNode;
    adminOnly?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, adminOnly = false }) => {
    const { user, isAdmin, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="min-h-screen bg-black flex items-center justify-center text-white opacity-50">Autenticando...</div>;
    }

    if (adminOnly) {
        if (!user || !isAdmin) {
            return <Navigate to="/banana/login" state={{ from: location }} replace />;
        }
        return <>{children}</>;
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};
